import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useNotify from "hooks/useNotify";
import externalPageApi from "api/externalPage";

const useConfirmFinanceGroupedInvoice = () => {
  const [t] = useTranslation();
  const navigate = useNavigate();
  const { notifyError } = useNotify();
  const { search, pathname } = useLocation();
  const { token } = useParams();

  const approvedParam = new URLSearchParams(search).get("approved");
  const [isLoading, setIsLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const isGroupedInvoice = pathname?.includes("groupedInvoice");
  useEffect(() => {
    if (!token) return;

    const fetchData = async () => {
      try {
        const response = await externalPageApi.listGroupedInvoiceOrOrderDetails(
          token
        );
        setData(response.data);
      } catch (err) {
        setError("Failed to load invoice/order details.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      const payload = {
        token,
        acceptance: approvedParam,
        rejectionReason: rejectionReason,
      };

      await externalPageApi.respondFinanceGroupedInvoice(payload);
      setSuccessMsg(
        approvedParam === "true"
          ? t("rejectionReasonAcceptEndMsg")
          : t("rejectionReasonDeclineEndMsg")
      );
    } catch (err) {
      console.error(err);
      notifyError(
        err?.response?.data?.message ?? err?.message ?? "Something went wrong!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    onSubmit,
    navigate,
    isLoading,
    approvedParam,
    successMsg,
    setRejectionReason,
    data: data?.length ? data[0] : [],
    loading,
    error,
    isGroupedInvoice,
  };
};

export default useConfirmFinanceGroupedInvoice;
